import { DateFormatType, formatDate } from "~/utils/datetime"

const MAX_TOOLTIP_VALUES = 10

export const formatValue = (value: string | number | Date): string => {
  if (value instanceof Date) {
    return formatDate(value, DateFormatType.FullDateShort)
  }
  return value.toString()
}

/** Joins values for a tooltip, capping at the first 10 with an "…and N more" suffix. */
export const formatValueList = (values: (string | number | Date)[]): string => {
  const shown = values.slice(0, MAX_TOOLTIP_VALUES).map(formatValue).join(", ")
  const extra = values.length - MAX_TOOLTIP_VALUES
  return extra > 0 ? `${shown} …and ${extra} more` : shown
}
